<template>
  <div class="createdProductGroup">
    <ul v-if="groups.length">
      <li v-for="(group,index) in groups" :key="index">
        <div class="group_detail">
           <router-link :to="`/detail/${ group.itemId}`">
          <span class="group_image">
             <span v-if="group.title">{{group.title.charAt(0)}}</span>
            <img src="../../../assets/images/dummy.png" alt="dummy" v-else />
          </span>
           </router-link>
          <div class="list_detail">
            <p class="name">
              <span>{{group.title}}</span>
              <span><span class="location" v-if="group.cityName"> &nbsp;|&nbsp; {{$t('from',{location:group.cityName})}}</span>
              </span>
            </p>
            <p class="count">
              <span v-if="group.groupMemeberCount">{{$t('totalMember')}} : {{group.groupMemeberCount}}</span> 
              <span v-if="group.groupDiscount">&nbsp;|&nbsp; {{$t('groupDiscount')}} : ₹ {{group.groupDiscount}}</span>
            </p>
           
          </div>
          <div class="bottom_section">
           <p class="left_item">
              <span>
                {{$t('discountExpire')}} :
                <Timer
                  @StopTime="timerStop"
                  :timing="getTime(group.groupExpiryDate,index)"
                  :Index="index"
                  :GroupID="group.groupId"
                />
              </span>
            </p>
          <span
            class="buy_in_group"
            v-if="group.status"
            @click="readyTobuyInGroup(group.groupId, group.minOrdersToFormNewGroup)"
          >{{$t('buyNow')}}</span>
          </div>
        </div>
      </li>
    </ul>
    <div class="groupTerms" v-if="openTerms">
      <i class="material-icons" @click="openTerms = !openTerms">close</i>
      <h3 class="heading">{{$t('productTerm')}}</h3>
      <ul>
        <li> {{$t('getDeal', {minOrderId : minOrderId})}}</li>
        <li>{{$t('makePayment')}}</li>
        <li>{{$t('refundMoney')}}</li>
      </ul>
      <div class="term_button">
        <button type="button" class="proceed_button" @click="buyInGroup">{{$t('goAhead')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "../../../main";
import Timer from "../../Common/TimeCount";
export default {
  name: "CreatedProductGroup",
  props: {
    groupValue: {
      required: true,
      type: Array
    }
  },
  components: {
    Timer
  },
  data() {
    return {
      groupExpireTime: "",
      groupId: null,
      openTerms: false,
      GroupData: [],
      minOrderId: ''
    };
  },
  computed:{
    groups(){
      return this.groupValue
    }
  },
  watch: {
    groupValue() {
      if (this.groupValue.length) {
        this.GroupData = this.groupValue;        
      }
    }
  },
  methods: {
    timerStop(obj) {
      if(this.GroupData.length > 0){
      this.GroupData[obj.index].status = false;
      }
    },
    getTime(value, index) {
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    callbackFunction() {
      this.$router.go(-1);
    },
    readyTobuyInGroup(id, totalNumber) {
      this.groupId = id;
      this.minOrderId = totalNumber
      this.openTerms = !this.openTerms;
    },
    buyInGroup() {
      clevertap.event.push("JOIN_GROUP");
      try {
        JSBridgePlugin.joinMall91Group(this.groupId);
      } catch (err) {
        console.log(err);
      }
    }
  },
  mounted() {
    if (this.groupValue.length > 0) {
      this.GroupData = this.groupValue;
    }
  }
};
</script>
